<template>
    <div class="modal-window dts008">
      <!-- 보드복제 게시 팝업 S -->
      <div class="modal-header">
        <div class="tit">{{ $i18nUtil.trans("title.CopyInfoShareBoardModal.001","보드 복제") }}</div>
        <button @click="$emit('close')" class="btn_close">닫기</button>
      </div>

      <div class="modal-content">
        <div class="info-txt">{{ $i18nUtil.trans("message.CopyInfoShareBoardModal.001","보드 복제를 위해 카테고리 위치를 선택해주세요.") }}</div>
        
        <div class="btm">
          <div class="dropdown ty2 wide relative">
            <v-menu bottom left>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" :class="selectedCategoryName == '' ? 'disabled' : 'ell-singleline'">{{selectedCategoryName == '' 
                    ? $i18nUtil.trans("entity.category.search.select","카테고리 선택")
                    : selectedCategoryName
                  }}</v-btn>
              </template>
              <div class="dropdown-list">
                <div class="scroll">
                  <div class="dropdown-list-item" v-if="shareCategoryList == null || shareCategoryList.length == 0">
                    <div class="tit">
                      <button type="button">{{ $i18nUtil.trans("message.CopyInfoShareBoardModal.002","선택 가능한 카테고리가 없습니다.") }}</button>
                    </div>
                  </div>
                  <div class="dropdown-list-item" 
                    v-else 
                    v-for="(shareCategoryItem, shareCategoryIndex) in shareCategoryList"
                    :key="shareCategoryIndex"
                    :class="selectedCategoryMid == shareCategoryItem.categoryMid ? 'active' : ''"
                    @click="changeCategoryItem(shareCategoryItem)"
                  >
                    <div class="tit">
                      <button type="button" class="ell-singleline">
                        {{shareCategoryItem.categoryName}}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </v-menu>
          </div>
          <div class="error" v-if="error">{{$i18nUtil.trans('UB007')}}</div>
        </div>
      </div>
      <footer class="modal-footer">
        <button type="button" class="btn_ty1" @click="onClickSubmit">{{ $i18nUtil.trans("button.copy","복제") }}</button>
      </footer>
    </div>
    <!-- 보드복제 게시 팝업 E -->    
</template>

<script>
import { mapActions } from "vuex";
import axios from "axios";

export default {
  props: {
    modalInfo: {
      type: Object,
      required: true,
    },
  },
  components: {

  },
  data() {
    return {
      categoryItem:null,
      selectedCategoryMid : null,
      selectedCategoryName : '',
      paperId: this.$props.modalInfo.paperId,
      shareCategoryList : [],
      error: false,
      toastInfo: {
          obj: this.$toasted,
          message: "",
          options: {
          theme: "toasted-primary",
          position: "bottom-left",
          duration: 3000,
          },
      },
      addCategoryName:"",
    }
  },
  mounted() {
    this.initShareCategoryList();
  },
  methods: {
    ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
    ...mapActions("modals", ["showToast", "showModal"]),
    /* 정보공유 카테고리 리스트 조회 */
    initShareCategoryList() {
        let obj = this;
        let reqData = {};
        reqData.req = obj.req;
        // 공개 + 멤버인 카테고리 리스트 
        reqData.url = "/api/copaper/infoshare/getShareCategoryListNormalAndRestrict";
        reqData.method = "post";
        reqData.params = {
            parentCategoryMid : "",
        };
        obj.showLoadingbar();
        obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then(function (res) { 
            obj.hideLoadingbar();
            obj.shareCategoryList = res.result.categoryList;
            // obj.selectedCategoryMid = obj.shareCategoryList[0].categoryMid;
            // obj.categoryItem=res.result[0];
        })
        .catch(function (err) {
            obj.hideLoadingbar();
            console.log(err);
        });
    },
    /* 카테고리 변경 이벤트 */
    changeCategoryItem(shareCategoryItem) {
      let obj = this;
      obj.categoryItem = shareCategoryItem;
      obj.selectedCategoryMid = shareCategoryItem.categoryMid;
      obj.selectedCategoryName = shareCategoryItem.categoryName;
      obj.error = false;
    },
    /* 게시요청 */
    onClickSubmit() { 
      if(this.selectedCategoryMid === null) {
          this.error = true;
          return;
      }
      this.showLoadingbar();
      let obj = this;
      let reqData = {};
      reqData.req = obj.req;
      reqData.url = "/api/copaper/infoshare/copySharePaper";
      reqData.method = "post";
      reqData.params = {
        siteId: this.categoryItem.sharePointSiteId, // root 밑 문서라이브러리아이디 
        folderId: this.categoryItem.sharePoinFolderId,//
        paperId: this.paperId,
        categoryMid:this.categoryItem.categoryMid, 
        type: "SHAR",
      };
      obj
      .COWORK_REST_SIMPLE_ACTION(reqData)
      .then(function (res) {
          obj.hideLoadingbar();
          if(res.errorCode) {
            console.log('/copySharePaper errorCode', res.errorCode);
            return;
          }
          obj.toastInfo.message =  obj.$i18nUtil.trans('TB019');
          obj.showToast(obj.toastInfo);
          obj.$emit("close");
      })
      .catch(function (err) {
          obj.hideLoadingbar();
          console.log(err);
      });
        
    },
  },
  watch: {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/cowork/general/board/modal/CopyInfoShareBoardModal.vue